import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
  state('void', style({ opacity: 0, overflow: 'hidden' })),
  transition(':enter', [animate('250ms ease-in', style({ opacity: 1 }))]),
]);
